export default __webpack_public_path__ + "static/media/Bridget-Conway-Taylor.bce6d350.jpg";